import { render, staticRenderFns } from "./editCargoHelpersDialog.vue?vue&type=template&id=7477ed2c&"
import script from "./editCargoHelpersDialog.vue?vue&type=script&lang=js&"
export * from "./editCargoHelpersDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports